import { lazy, Suspense } from 'react';
import { Navigate, Outlet } from 'react-router-dom';
// auth
import { StandardPolicyGuard } from 'src/auth/guard';
// layouts
import AppLayout from 'src/layouts/app';
// components
import { LoadingScreen } from 'src/components/loading-screen';

const ProductsListPage = lazy(() => import('src/pages/products/products'));
const ProductAnalyticsPage = lazy(() => import('src/pages/products/analytics'));
const ProductDetailPage = lazy(() => import('src/pages/products/productDetail'));

export const productsRoutes = [
  {
    path: 'products',
    element: (
      <StandardPolicyGuard
        fallback={
          <AppLayout>
            <LoadingScreen />
          </AppLayout>
        }
      >
        <AppLayout>
          <Suspense fallback={<LoadingScreen />}>
            <Outlet />
          </Suspense>
        </AppLayout>
      </StandardPolicyGuard>
    ),
    children: [
      { path: '', element: <Navigate to="list" replace />, index: true },
      { path: 'list', element: <ProductsListPage /> },
      { path: 'analytics', element: <ProductAnalyticsPage /> },
      { path: ':id', element: <ProductDetailPage /> },
    ],
  },
];
